import { Component, OnInit, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-previous-illness-info',
  templateUrl: './previous-illness-info.component.html',
  styleUrls: ['./previous-illness-info.component.scss']
})
export class PreviousIllnessInfoComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  editIcon = this.RESOURCE_SERVER_URL + '/assets/images/Edit.svg';
  previousIllnessText: any;

  constructor(
    private commonService: CommonService,
    private dialogRef: MatDialogRef<PreviousIllnessInfoComponent>,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  ngOnInit(): void {
    this.previousIllnessText = this.data.previousIllnessText;
  }
  onChange(event) {}
  async onCloseDialog() {
    this.dialogRef.close();
  }

}
